import ReactSelectAsync from 'react-select/async';
import ReactSelectAsyncCreatable from 'react-select/async-creatable';
import ReactSelect from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';

const useSelectComponent = (isAutocomplete, async) => {
  if (isAutocomplete) {
    return async ? ReactSelectAsyncCreatable : ReactSelectCreatable;
  }

  return async ? ReactSelectAsync : ReactSelect;
};

export default useSelectComponent;
